import { logAuthConsents } from "./consentLogging";

export const handleSuccessfulAuthCallback = async ({
  user,
  role,
  setStatus,
  logUserConsent,
  logger,
}) => {
  logger.info("AuthCallback: success", { email: user.email, role });
  setStatus("success");

  setTimeout(() => {
    logAuthConsents({ email: user.email, logUserConsent })
      .then(() => {
        logger.info("AuthCallback: consents logged");
      })
      .catch((error) => {
        logger.error("AuthCallback: consent logging error", error);
      });
  }, 0);
};
